





























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Location } from 'vue-router'
import { buscarAtualizacoes, marcarComoLida } from '@/api/novidades'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { Atualizacao } from '@/shareds/novidades/modelo'
import {
	contagem,
	gruposDoIndice,
	imagensDaLeitura,
	parteDoMes,
	vizinhas,
} from '@/shareds/novidades/modelo'
import { renderizarCorpo } from '@/shareds/novidades/renderizar'
import { tokensDeTema } from '@/shareds/novidades/tema'
import { primaryColor } from '@/plugins/vuetify'
import { estadoDaLista, itemPedido, prefereMenosMovimento } from '@/shareds/novidades/navegacao'
import RaizDeNovidades from './RaizDeNovidades.vue'
import EtiquetaDeArea from './EtiquetaDeArea.vue'
import IndiceDaAtualizacao from './IndiceDaAtualizacao.vue'
import VisualizadorDeImagem from './VisualizadorDeImagem.vue'

@Component({ components: { RaizDeNovidades, EtiquetaDeArea, IndiceDaAtualizacao, VisualizadorDeImagem } })
export default class LeituraDaAtualizacao extends Vue {
	@Prop({ type: String, required: true }) id!: string

	lista: Atualizacao[] = []
	carregando = true
	erro = false
	atual: number | null = null
	zoom: number | null = null
	menuDoIndice = false
	observador: IntersectionObserver | null = null
	observadorDoFim: IntersectionObserver | null = null

	get atualizacao() {
		return this.lista.find(a => a.id === this.id) || null
	}

	/** O menu do índice no celular abre fora da raiz da tela: leva as mesmas cores. */
	get tokens() {
		return tokensDeTema(primaryColor(), this.$vuetify.theme.dark)
	}

	get indiceLateral() {
		return this.$vuetify.breakpoint.lgAndUp
	}

	get grupos() {
		return this.atualizacao ? gruposDoIndice(this.atualizacao) : []
	}

	get mostrarGrupos() {
		return this.grupos.some(g => g.grupo !== null)
	}

	get parte() {
		return this.atualizacao ? parteDoMes(this.atualizacao) : ''
	}

	get contagem() {
		return this.atualizacao ? contagem(this.atualizacao) : ''
	}

	get introducao() {
		return this.atualizacao && this.atualizacao.introducao ? renderizarCorpo(this.atualizacao.introducao) : ''
	}

	get htmlDosItens(): Record<number, string> {
		const html: Record<number, string> = {}
		if (this.atualizacao) for (const item of this.atualizacao.itens) html[item.ordem] = renderizarCorpo(item.corpo)
		return html
	}

	get imagens() {
		return this.atualizacao ? imagensDaLeitura(this.atualizacao) : []
	}

	get anterior() {
		return vizinhas(this.lista, this.id).anterior
	}

	get proxima() {
		return vizinhas(this.lista, this.id).proxima
	}

	get rotaDaLista(): Location {
		return { name: 'Novidades', query: estadoDaLista.consulta }
	}

	get rotuloDoIndiceMovel() {
		const total = this.atualizacao ? this.atualizacao.itens.length : 0
		const item = this.atualizacao && this.atual ? this.atualizacao.itens[this.atual - 1] : null
		return item ? `${item.ordem} de ${total} · ${item.titulo}` : `Índice · ${total} itens`
	}

	rotaDe(a: Atualizacao): Location {
		return { name: 'Novidade', params: { id: a.id } }
	}

	resumoDaVizinha(a: Atualizacao) {
		return [parteDoMes(a), contagem(a)].filter(Boolean).join(' · ')
	}

	async carregar() {
		this.carregando = true
		this.erro = false
		try {
			this.lista = await buscarAtualizacoes()
		} catch (e) {
			this.erro = true
		} finally {
			this.carregando = false
		}
		this.aoMostrar()
	}

	aoMostrar() {
		this.atual = null
		this.zoom = null
		this.menuDoIndice = false
		if (!this.atualizacao) return
		marcarComoLida(this.atualizacao.id).catch(() => undefined)
		this.$nextTick(() => {
			const item = itemPedido(this.$route.query, this.$route.hash)
			if (item && this.atualizacao && item <= this.atualizacao.itens.length) {
				this.irPara(item, false)
				this.manterNoItemEnquantoCarrega(item)
			} else {
				window.scrollTo(0, 0)
			}
			this.observar()
		})
	}

	/** Item atual: o primeiro cartão na faixa de cima da tela, descontada a barra do topo. */
	observar() {
		this.desobservar()
		const cartoes = Array.from(this.$el.querySelectorAll<HTMLElement>('.nov-cartao[data-item]'))
		if (!cartoes.length || typeof IntersectionObserver === 'undefined') return
		const barraDoIndice = this.$el.querySelector<HTMLElement>('.nov-indice-movel')
		const topo = this.$vuetify.application.top + (barraDoIndice ? barraDoIndice.offsetHeight : 0) + 24
		const naFaixa = new Set<number>()
		this.observador = new IntersectionObserver(entradas => {
			for (const entrada of entradas) {
				const n = Number((entrada.target as HTMLElement).dataset.item)
				if (entrada.isIntersecting) naFaixa.add(n)
				else naFaixa.delete(n)
			}
			if (naFaixa.size) this.atual = Math.min(...naFaixa)
		}, { rootMargin: `-${topo}px 0px -55% 0px` })
		cartoes.forEach(c => this.observador && this.observador.observe(c))

		const fim = this.$refs.fim as HTMLElement | undefined
		if (!fim) return
		this.observadorDoFim = new IntersectionObserver(([entrada]) => {
			if (entrada.isIntersecting) this.atual = cartoes.length
		})
		this.observadorDoFim.observe(fim)
	}

	desobservar() {
		if (this.observador) this.observador.disconnect()
		if (this.observadorDoFim) this.observadorDoFim.disconnect()
		this.observador = null
		this.observadorDoFim = null
	}

	irPara(n: number, suave = true) {
		const cartao = document.getElementById(`item-${n}`)
		if (!cartao) return
		const barraDoIndice = this.$el.querySelector<HTMLElement>('.nov-indice-movel')
		const desconto = this.$vuetify.application.top + 16 + (barraDoIndice ? barraDoIndice.offsetHeight : 0)
		window.scrollTo({
			top: cartao.getBoundingClientRect().top + window.scrollY - desconto,
			behavior: suave && !prefereMenosMovimento() ? 'smooth' : 'auto',
		})
		this.atual = n
		if (suave) {
			const titulo = document.getElementById(`titulo-item-${n}`)
			if (titulo) titulo.focus({ preventScroll: true })
		}
		if (this.$route.query.item !== String(n)) {
			this.$router.replace({ query: { ...this.$route.query, item: String(n) } }).catch(() => undefined)
		}
	}

	/**
	 * No link direto para um item, as imagens que carregam perto dele empurram o cartão para baixo.
	 * Durante um instante, cada imagem carregada realinha o cartão, até a pessoa rolar por conta própria.
	 */
	manterNoItemEnquantoCarrega(n: number) {
		const artigo = this.$refs.artigo as HTMLElement | undefined
		if (!artigo) return
		let ativo = true
		const parar = () => {
			ativo = false
			artigo.removeEventListener('load', realinhar, true)
			window.removeEventListener('wheel', parar)
			window.removeEventListener('touchstart', parar)
			window.removeEventListener('keydown', parar)
		}
		const realinhar = () => {
			if (ativo) this.irPara(n, false)
		}
		artigo.addEventListener('load', realinhar, true)
		window.addEventListener('wheel', parar, { passive: true })
		window.addEventListener('touchstart', parar, { passive: true })
		window.addEventListener('keydown', parar)
		setTimeout(parar, 2500)
	}

	irPeloIndice(n: number) {
		this.irPara(n)
		this.manterNoItemEnquantoCarrega(n)
	}

	irDoMenu(n: number) {
		this.menuDoIndice = false
		this.$nextTick(() => this.irPeloIndice(n))
	}

	async copiarLink(n: number) {
		const link = `${window.location.origin}/novidades/${encodeURIComponent(this.id)}?item=${n}`
		try {
			await navigator.clipboard.writeText(link)
			AlertModule.setSuccess('Link do item copiado.')
		} catch (e) {
			AlertModule.setError('Não foi possível copiar o link. Copie o endereço do navegador.')
		}
	}

	abrirImagem(alvo: EventTarget | null) {
		const img = alvo as HTMLElement | null
		if (!img || img.tagName !== 'IMG' || !img.hasAttribute('data-ampliavel')) return false
		const artigo = this.$refs.artigo as HTMLElement
		const todas = Array.from(artigo.querySelectorAll('.nov-cartao img[data-ampliavel]'))
		const indice = todas.indexOf(img)
		if (indice < 0) return false
		this.zoom = indice
		return true
	}

	aoClicarNoConteudo(evento: MouseEvent) {
		this.abrirImagem(evento.target)
	}

	aoTeclarNoConteudo(evento: KeyboardEvent) {
		if (evento.key !== 'Enter' && evento.key !== ' ') return
		if (this.abrirImagem(evento.target)) evento.preventDefault()
	}

	@Watch('atual')
	acompanharNoIndice(n: number | null) {
		const indice = this.$refs.indiceLateral as HTMLElement | undefined
		if (!n || !indice) return
		const link = indice.querySelector<HTMLElement>(`[data-indice="${n}"]`)
		if (!link) return
		const cima = link.offsetTop
		const baixo = cima + link.offsetHeight
		if (cima < indice.scrollTop + 16 || baixo > indice.scrollTop + indice.clientHeight - 16) {
			indice.scrollTop = cima - indice.clientHeight / 2
		}
	}

	@Watch('id')
	aoTrocarDeAtualizacao() {
		this.aoMostrar()
	}

	@Watch('indiceLateral')
	aoMudarDeLargura() {
		this.$nextTick(() => this.observar())
	}

	created() {
		this.carregar()
	}

	beforeDestroy() {
		this.desobservar()
	}
}
